import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Outlet } from 'react-router-dom';
import { Footer } from '../common/Footer';
import { Header } from '../common/Header';
export const SuccessLayout = () => {
    return (_jsxs("div", { children: [_jsx(Header, {}), _jsx(Outlet, {}), _jsx(Footer, {})] }));
};
